module.exports = __webpack_public_path__ + "img/tool-check.985aae7.webp";